import type { TFunction } from 'i18next';

export const getDimensionsErrors = (
  translate: TFunction
): {
  [key: string]: {
    required: string;
    value: RegExp;
    pattern: string;
  };
} => ({
  length: {
    required: translate('dimensionsErrors.length.required'),
    value: /^\d{1,3}([,.]\d{1,2})?$/,
    pattern: translate('dimensionsErrors.length.pattern'),
  },
  width: {
    required: translate('dimensionsErrors.width.required'),
    value: /^\d{1,3}([,.]\d{1,2})?$/,
    pattern: translate('dimensionsErrors.width.pattern'),
  },
  area: {
    required: translate('dimensionsErrors.area.required'),
    value: /^\d{1,3}([,.]\d{1,2})?$/,
    pattern: translate('dimensionsErrors.area.pattern'),
  },
  layerThickness: {
    required: translate('dimensionsErrors.layerThickness.required'),
    value: /^\d{1,3}$/,
    pattern: translate('dimensionsErrors.layerThickness.pattern'),
  },
  height: {
    required: translate('dimensionsErrors.height.required'),
    value: /^\d{1,2}([,.]\d{1,2})?$/,
    pattern: translate('dimensionsErrors.height.pattern'),
  },
});
